import {
  IMenhirWelfareBalance,
  IWelfareBalance,
} from '@/common/integrations/menhir/employee/welfare/welfare.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';

export const getWelfareBalance = (): Promise<IWelfareBalance> =>
  menhirClient
    .get<null, IMenhirWelfareBalance>(MENHIR_ENDPOINTS.EMPLOYEE.WELFARE.BALANCE)
    .then(({ available_balance }) => ({
      availableBalance: available_balance,
    }));
